import React, { FunctionComponent, MouseEventHandler } from 'react';
import { useLocation, useMatch } from 'react-router-dom';

import { useAutoScrollIntoView } from '../../hooks/useAutoScrollIntoView';

import { $Counter, $RouteTabLink, $RouteTabSize } from './RouteTabs.styles';

interface RouteTabsLinkProps {
  url: string;
  isActive?: boolean;
  count: number;
  dataTestId?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  level: 1 | 2;
  isHidden?: boolean;
  name: string;
}

const RouteTabsLink: FunctionComponent<
  React.PropsWithChildren<RouteTabsLinkProps>
> = ({
  children,
  url,
  count,
  dataTestId,
  onClick,
  level,
  isHidden,
  isActive,
  name,
}) => {
  const location = useLocation();
  const isActiveLocal = useMatch(`${url}/*`) ?? isActive;
  const ref = useAutoScrollIntoView<HTMLAnchorElement>(
    location.hash === `#${name}`,
  );

  return (
    <$RouteTabSize>
      <$RouteTabLink
        to={url}
        $isActive={!!isActiveLocal}
        $count={count}
        data-testid={`RouteTabs-${dataTestId}`}
        onClick={onClick}
        $level={level}
        $isHidden={isHidden}
        data-active={!!isActiveLocal}
        id={name}
        ref={ref}
      >
        {children}
      </$RouteTabLink>
      {count > 0 && <$Counter>{count}</$Counter>}
    </$RouteTabSize>
  );
};

export default RouteTabsLink;
